import apiClient from '../axios.js';

export const shareRewardCampaignService = {
  getCampaigns: async (params = {}) => {
    const response = await apiClient.get('/admin/share-reward-campaigns', { params });
    return response;
  },

  getCampaign: async (id) => {
    const response = await apiClient.get(`/admin/share-reward-campaigns/${id}`);
    return response;
  },

  createCampaign: async (payload) => {
    const response = await apiClient.post('/admin/share-reward-campaigns', payload);
    return response;
  },

  updateCampaign: async (id, payload) => {
    const response = await apiClient.put(`/admin/share-reward-campaigns/${id}`, payload);
    return response;
  },

  deleteCampaign: async (id) => {
    const response = await apiClient.delete(`/admin/share-reward-campaigns/${id}`);
    return response;
  },

  getCampaignStats: async (id) => {
    const response = await apiClient.get(`/admin/share-reward-campaigns/${id}/stats`);
    return response;
  },

  getParticipants: async (id, params = {}) => {
    const response = await apiClient.get(`/admin/share-reward-campaigns/${id}/participants`, { params });
    return response;
  },

  getActiveCampaign: async () => {
    const response = await apiClient.get('/share-reward-campaigns/active');
    return response;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  }
};
